export default {
  actionableStatuses: (state) => state.actionableStatuses,
  attestationConfirmationsPending: (state) => state.attestationConfirmationsPending,
  attestationDetail: (state) => state.attestationDetail,
  attestationHistory: (state) => state.attestationHistory,
  attestationHistoryDetail: (state) => state.attestationHistoryDetail,
  attestations: (state) => state.attestations,
  attestationsLoading: (state) => state.attestationsLoading,
  attestationPollingHandle: (state) => state.attestationPollingHandle,
  attestationRequestsPending: (state) => state.attestationRequestsPending,
}
